import { Feature } from './routes/sortFiltersParams';

export type AppDefIdsByFeature = Record<Feature, AppName[]>;
export type FeatureByAppDefId = Record<AppName, Feature>;

export type AppName =
  | 'stores'
  | 'wixProGallery'
  | 'bookings'
  | 'blogs'
  | 'music'
  | 'video'
  | 'instagram'
  | 'restaurantsMenus'
  | 'restaurantsOrders'
  | 'reservations'
  | 'wixEvents'
  | 'pricingPlans'
  | 'forum';
export type Apps = Record<AppName, string>;

export const PRODUCTION_APPS: Apps = {
  stores: '1380b703-ce81-ff05-f115-39571d94dfcd',
  wixProGallery: '14271d6f-ba62-d045-549b-ab972ae1f70e',
  bookings: '13d21c63-b5ec-5912-8397-c3a5ddb27a97',
  blogs: '14bcded7-0066-7c35-14d7-466cb3f09103',
  music: '13bb5d67-1add-e770-a71f-001277e17c57',
  video: '14409595-f076-4753-8303-9a86f9f71469',
  instagram: '14635256-b183-1c71-a4d2-f55179b80e8a',
  restaurantsMenus: '13c1402c-27f2-d4ab-7463-ee7c89e07578',
  restaurantsOrders: '13e8d036-5516-6104-b456-c8466db39542',
  reservations: '1475ab65-206b-d79a-856d-fa10bdb479ea',
  forum: '14724f35-6794-cd1a-0244-25fd138f9242',
  wixEvents: '140603ad-af8d-84a5-2c80-a0f60cb47351',
  pricingPlans: '1522827f-c56c-a5c9-2ac9-00f9e6ae12d3',
};

export const APPS_BY_FEATURE: AppDefIdsByFeature = {
  store: ['stores'],
  booking: ['bookings'],
  events: ['wixEvents'],
  blog: ['blogs'],
  forum: ['forum'],
  gallery: ['wixProGallery'],
  music: ['music'],
  video: ['video'],
  pricing: ['pricingPlans'],
  instagram: ['instagram'],
  restaurant: ['restaurantsMenus', 'restaurantsOrders', 'reservations'],
};

export const FEATURE_BY_APP_DEF_ID: FeatureByAppDefId = {
  stores: 'store',
  bookings: 'booking',
  blogs: 'blog',
  forum: 'forum',
  wixProGallery: 'gallery',
  music: 'music',
  video: 'video',
  instagram: 'instagram',
  restaurantsMenus: 'restaurant',
  restaurantsOrders: 'restaurant',
  reservations: 'restaurant',
  pricingPlans: 'pricing',
  wixEvents: 'events',
};

export const getAppNameByDefId = (apps: Apps, appDefId: string): AppName | undefined => {
  const [appName] = Object.entries(apps).find(([, defId]) => defId === appDefId) || [];
  return appName as AppName | undefined;
};

export const getFeatureByApp = (app: AppName): Feature | undefined => {
  const [feature] = Object.entries(APPS_BY_FEATURE).find(([, appsByFeature]) => appsByFeature.includes(app)) || [];
  return feature as Feature | undefined;
};
